import { createReducer } from '@reduxjs/toolkit';
import { fetchConfiguration } from '../actions/appConfiguration';
const initialState = {
    listOfBannedWords: '',
    redactedText: '',
};
const appConfigurationReducer = createReducer(initialState, builder => {
    builder
        .addCase(fetchConfiguration.fulfilled, (state, action) => {
        return action.payload;
    })
        .addDefaultCase((state) => {
        return state;
    });
});
export default appConfigurationReducer;
//# sourceMappingURL=appConfiguration.js.map